/** Interval between visible-page deployment checks. */
export const FRONTEND_UPDATE_INTERVAL_MS = 5 * 60 * 1000;
/** Minimum delay between checks triggered by lifecycle events. */
export const FRONTEND_UPDATE_COOLDOWN_MS = 30 * 1000;
/** Maximum time allowed for a deployment manifest request. */
export const FRONTEND_UPDATE_TIMEOUT_MS = 10 * 1000;
/** Same-origin manifest cache key; independent of tenant and authentication. */
export const FRONTEND_BUILD_QUERY_KEY = ['frontend-build'];
/** Initial HTML identity captured before network checks; null in the dev server. */
export const RUNNING_FRONTEND_BUILD = __APP_BUILD__;
